// extracted by mini-css-extract-plugin
export default {"workflowsInstanceHeader":"workflowsInstanceHeader-a_ahj","header":"header-edHTQ","icon":"icon-GqELj","title":"title-qrq5t","menu":"menu-i0JDP"};